import { TRIGGER_PAN_SAVE_API, TRIGGER_PAN_SAVE_API_SUCCESS } from 'redux/actionTypes';

export function triggerPanSaveApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_PAN_SAVE_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerPanSaveApiCallSuccess(data) {
	return {
		type: TRIGGER_PAN_SAVE_API_SUCCESS,
		data,
	};
}
